import { SPREADSHEET_ID, CLIENT_ID, API_KEY, SCOPE } from './google-sheet-credentials';
import 'date-fns';
import React, { useState, useRef, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';

// radio buttons
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';

import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import TermsConditionList from './terms-condition-list';
import validator from 'validator';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import PrintIcon from '@material-ui/icons/Print';
import SendIcon from '@material-ui/icons/Send';
import Button from '@material-ui/core/Button';


import { useStyles } from './styles';
import { min, max, set } from 'date-fns';
import { formSubmitAction } from './form-submit-action';
import SubmitFormDialog from './submit-form-dialog';
import UploadFileDialog from './upload-file-dialog';
import EmbeddedBrowser from 'react-embedded-browser';

import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';

function AgentForm (props) {

    const currencyValObj = {
        loanAmtCurrency: '',
        transacVolCurrency: '',
    }

    const isDialogProps = {
        isOpen: false,
        agentName: '',
        msg: '',
        handleClose: '',
    }

    const isUploadDialogProps = {
        isOpen: false,
        uploadLink: '',
        handleUploadClose: '',
    }

    const fileValObj = {
        agentIdentityUpload: '',
        agentUtilityUpload: '',
        agentPassportUpload: '',
    }

    const btnChecksObj = {
        isTermsAgree: false,
        isCovenantAgree: false,
        agentIdentityUpload: false,
        agentUtilityUpload: false,
        agentPassportUpload: false,
    }
    
    const [fileVal, setFileVal] = useState(fileValObj);
    const [userDocs, setUserDocs] = useState({pictures: []});
    const [isTermsAgree, setIsTermsAgree] = useState(false);
    const [isCovenantAgree, setIsCovenantAgree] = useState(false);
    const [dialogProps, setDialogProps] = useState(isDialogProps);
    const [uploadDialogProps, setUploadDialogProps] = useState(isUploadDialogProps);
    const [isSubmitBtn, setIsSubmitBtn] = useState(false);
    const [hiddenLoanAmountVal, setHiddenLoanAmountVal] = useState('');
    const [hiddenTransacVolumeVal, setHiddenTransacVolumeVal] = useState('');
    const [isBtnChecks, setIsBtnChecks] = useState(btnChecksObj);

    const utilityFileRef = useRef(null);
    const identityFileRef = useRef(null);
    const passportFileRef = useRef(null);
    const idDisplayRef = useRef(null);
    const utilDisplayRef = useRef(null);
    const passportDisplayRef = useRef(null);
    const formTagRef = useRef(null);
    const covenantAgreeRef = useRef(null);
    const termsAgreeRef = useRef(null);
    const hiddenLoanAmountRef = useRef(null);
    const hiddenTransacVolumeRef = useRef(null)

    const handleFileChange = (e) => {
        setFileVal(prevState => {
            return {
                ...prevState,
                [e.target.name]: e.target.files[0],
            }
        })
        setUserDocs({
            pictures: userDocs['pictures'].concat({
                fieldName: e.target.name,
                fileObj: e.target.files[0]
            })
        })

        if((e.target.name == 'agentIdentityUpload')) {

            var idInput = e.target;

            var reader = new FileReader();
            reader.onload = () => {
                var dataSrc = reader.result;
                var output = idDisplayRef.current;
                output.src = dataSrc;
            }
            reader.readAsDataURL(idInput.files[0]);
            setIsBtnChecks({...isBtnChecks, agentIdentityUpload: true});

        }else if((e.target.name == 'agentUtilityUpload')) {

            var utilInput = e.target;

            var reader = new FileReader();
            reader.onload = () => {
                var dataSrc = reader.result;
                var output = utilDisplayRef.current;
                output.src = dataSrc;
            }
            reader.readAsDataURL(utilInput.files[0]);
            setIsBtnChecks({...isBtnChecks, agentUtilityUpload: true});

        }else if((e.target.name == 'agentPassportUpload')) {

            var passportInput = e.target;

            var reader = new FileReader();
            reader.onload = () => {
                var dataSrc = reader.result;
                var output = passportDisplayRef.current;
                output.src = dataSrc;
            }
            reader.readAsDataURL(passportInput.files[0]);
            setIsBtnChecks({...isBtnChecks, agentPassportUpload: true});
        }else {
            setIsBtnChecks({...isBtnChecks, agentPassportUpload: false});
            setIsBtnChecks({...isBtnChecks, agentUtilityUpload: false});
            setIsBtnChecks({...isBtnChecks, agentIdentityUpload: false});
        }

    }

    const handleCheckbox = (e) => {

        if(e.target.name === 'termsAgree') {

            setIsTermsAgree(prevState => {
                setIsBtnChecks({...isBtnChecks, isTermsAgree: !prevState});
                return !prevState
            });
        }else if (e.target.name === 'covenantAgree') {

            setIsCovenantAgree(prevState => {
                setIsBtnChecks({...isBtnChecks, isCovenantAgree: !prevState});
                return !prevState
            });
        }
        

        
    }

    const handleClose = () => {
        setDialogProps(prevState => {

            return {
                ...prevState,
                isOpen: false,
            }
        });
        window.location = '/';
    };

    // const handleUploadClose = () => {
    //     setUploadDialogProps(prevState => {

    //         return {
    //             ...prevState,
    //             isOpen: false,
    //         }
    //     });
    // };

    // const handleUploadBtnClick = (uploadLink) => {
    //     setUploadDialogProps(prevState => {

    //         return {
    //             ...prevState,
    //             isOpen: true,
    //             uploadLink,
    //             handleUploadClose
    //         }
    //     })
    // }

    const classes = useStyles();


    const formik = useFormik({

        initialValues: {
            loanAmount: '',
            bvn: '',
            firstname: '',
            lastname: '',
            email: '',
            phoneno: '',
            homeAddress: '',
            outstandingLoanInput: '',
            footerAgentName: '',
            footerAgentSign: '',
            acctNo: '',
            acctName: '',
            wallet: '',
            tin: '',
            rcno: '',
            transacVolume: '',
            loanDuration: '',
            busDurationYear: '',
            busDurationMonth: '',
            businessActivity: '',
            businessName: '',
            businessType: '',
            bankname: '',
            outstandingLoan: 'no',
            busDurationYear: '',
            busDurationMonth: '',
            businessActivity: '',
            covenantAgree: '',
            termsAgree: '',
            applicationDate: Date.now(),
        },
        validationSchema: Yup.object({
            
            loanAmount: Yup.number()
            .min(50000, 'Loan amount should not be less than N50,000')
            .max(500000, 'Loan amount should not be more than N250,000'),

            bvn: Yup.number()
            .min(11111111111, 'BVN number must not be less than 11')
            .max(99999999999, 'BVN number must not be more than 11'),

            email: Yup.string()
            .email('Invalid email address'),

            phoneno: Yup.number()
            .min(1111111111, 'Phone number must not be less than 11 digits')
            .max(9999999999, 'Phone number must not be more than 11 digits'),

            acctNo: Yup.number()
            .min(1111111111, 'Account number must not be less than 10 digits')
            .max(9999999999, 'Account number must not be more than 10 digits'),

            acctName: Yup.string(),
            
            wallet: Yup.number()
            .min(1111111111, 'Wallet ID must not be less than 11 digits')
            .max(9999999999, 'Wallet ID must not be more than 11 digits'),

            rcno: Yup.number()
            .min(1111111, 'RC number should not be less than 7 digits')
            .max(9999999, 'RC number should not be more than 7 digits'),

            tin: Yup.number()
            .min(1111111, 'Tin number should not be less than 7 digits')
            .max(9999999, 'Tin number should not be more than 7 digits'),

            transacVolume: Yup.number()
            .min(50000, 'Transaction volume should not be less than N50,000'),
        }),
        onSubmit: values => {

            if((isTermsAgree === false) && (isCovenantAgree === false) && (fileVal.agentIdentityUpload == '') && (fileVal.agentUtilityUpload == '')) {

                setDialogProps(prevState => {

                    return {
                        ...prevState,
                        isOpen: true,
                        names: '',
                        msg: 'Please accept the terms and conditions and upload documents before continuing this process, thank you!',
                        handleClose
                    }
                });
            }else if((isTermsAgree === true) && (isCovenantAgree === true) && (fileVal.agentIdentityUpload !== '') && (fileVal.agentUtilityUpload !== '')) {
                
                const params = {
                    isUrl: 'agent',
                    data: values
                }

                setDialogProps(prevState => {

                    return {
                        ...prevState,
                        isOpen: true,
                        names: '',
                        msg: '...Processing please wait!',
                        handleClose
                    }
                });

                setIsSubmitBtn(true);

                const submitResponse = formSubmitAction(params);
                submitResponse.then(submit => {

                    if(submit.result == 'success') {

                        var formData = new FormData();

                        userDocs.pictures.map((userDoc, index) => {

                            console.log(userDoc);

                            // // format file name
                            const agentName = `${values.firstname}-${values.phoneno}`;
                            const fileType = `${userDoc.fileObj.type}`;
                            const cleanFilename = `images/agents/${agentName.toLowerCase()}-${userDoc.fileObj.name.toLowerCase()}`;
                            formData.append(userDoc.fieldName, userDoc.fileObj, userDoc.fileObj.name);


                            const generatePutUrl = decodeURIComponent(`https://aws-file-uploader.herokuapp.com/generate-put-url?file-name=${cleanFilename}&file-type=${fileType}`);
                            
                            fetch(generatePutUrl, {
                                method: 'GET'
                            })
                            .then(response => response.json())
                            .then(data => {
                                console.log(data)
                                const putURL = data;
                                fetch(putURL, {
                                    method: 'PUT',
                                    body: userDoc.fileObj,
                                })
                                .then(res => {
    
                                    console.log(res);
                                    
                                    setDialogProps(prevState => {
    
                                        return {
                                            ...prevState,
                                            isOpen: true,
                                            fetchStatus: 'success',
                                            names: values.firstname+' '+values.lastname,
                                            summary: {
                                                loanDuration: values.loanDuration,
                                                serviceFee: 5,
                                                loanAmount: values.loanAmount,
                                            },
                                            msg: 'Thanks for submitting your application, please review your loan summary below.',
                                            handleClose
                                        }
                                    });
                                    setIsSubmitBtn(false);
                                })
                                .catch(err => {
    
                                    setDialogProps(prevState => {
    
                                        return {
                                            ...prevState,
                                            isOpen: true,
                                            fetchStatus: 'failed',
                                            names: values.firstname+' '+values.lastname,
                                            summary: {},
                                            msg: 'Seems like something went wrong, pls try again!',
                                            handleClose
                                        }
                                    });
                                    setIsSubmitBtn(false);
                                })

                            })
                            .catch(err => {
                                setDialogProps(prevState => {
    
                                    return {
                                        ...prevState,
                                        isOpen: true,
                                        fetchStatus: 'failed',
                                        names: values.firstname+' '+values.lastname,
                                        summary: {},
                                        msg: 'Seems like something went wrong, pls try again!',
                                        handleClose
                                    }
                                });
                                setIsSubmitBtn(false);
                            })
                        })

                        
                    }
                });
            }
        }
    })

    return (
        <div className="agent-form-container">
            <SubmitFormDialog dialogProps={dialogProps} />
            {/* <UploadFileDialog uploadDialogProps={uploadDialogProps} /> */}
            <div className="agent-form-container-flex">
                <div className="agent-form-container-item">
                    <div className="agent-form-header-body-cover-flex">
                        <div className="agent-form-header-body-cover-item">
                            <div className="agent-form-header-cover">
                                <div className="company-logo-header-cover">
                                    <div className="logo-header-cover-flex">
                                        <div className="logo-header-cover-item">
                                            <div className="image-cover-flex">
                                                <div className="image-cover-item">
                                                    <img className="header-logo-img" src="/assets/images/mkobo-logo.png" alt="mkobo image" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="logo-header-cover-item">
                                            <div className="image-cover-flex">
                                                <div className="image-cover-item">
                                                    <img className="header-logo-img" src="/assets/images/etransact-logo.png" alt="etransact image" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="agent-form-header">
                                    <h2 className="agent-form-header-title">LIFELINE AWC AGENT FORM</h2>
                                    <p className="agent-form-header-text">MKOBO’s Agent Working Capital (AWC) provides quick access to funding of up to <b>N500,000</b> to Agent Banks to help them increase their transaction volume thereby helping grow their agent banking business.</p>
                                </div>
                            </div>
                            <div className="agent-form-body-cover">
                                <div className="agent-form-body">
                                    <div className="agent-form-body-text-flex">
                                        <div className="agent-form-body-text-item">
                                            <p className="agent-form-body-text agent-form-body-text-left">
                                                <b>Product Features:</b><br />
                                            </p>
                                            <ul className="agent-form-body-ul">
                                                <li>Loan Amount N50,000 to N500,000</li>
                                                <li>N100 disbursement fee</li>
                                                <li>Tenure - 4 Weeks</li>
                                                <li>Weekly Repayment</li>
                                                <li>A small service fee will apply.</li>
                                                <li>Weekly repayment deducted from Agents’ wallets.</li>
                                                <li>Loan size determined by average transaction over 12 months period</li>
                                            </ul>
                                        </div>
                                        <div className="agent-form-body-text-item">
                                            <p className="agent-form-body-text agent-form-body-text-left">
                                                <b>Requirements:</b><br />
                                            </p>
                                            <ul className="agent-form-body-ul">
                                                <li>Agent must be a registered with one of AWC’s Business Partners</li>
                                                <li>Agent must have been registered for at least <b>12months.</b></li>
                                                <li>Agent must have been active for a minimum of <b>12months.</b></li>
                                                <li>Agent must do a minimum daily average transaction of <b>N50,000</b></li>
                                                <li>Agent may be required to provide a guarantor if necessary.</li>
                                                <li>Agent must provide a govt approved /valid means of ID <b>(Passport, Drivers Licence or National ID)</b></li>
                                                <li>Agent must provide his/her Bank Verification Number <b>(BVN)</b></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-container">
                        <form className={`${classes.formRoot} form-tag-cover`} id="agent-form-tag-cover" encType="multipart/form-data" ref={formTagRef} onSubmit={formik.handleSubmit}>
                            <div className="loan-details-cover">
                                <div className="loan-details-cover-header">
                                    <h2 className="header-title">Loan Details</h2>
                                </div>
                                <div className="loan-details-cover-body">
                                    <div className="loan-details-cover-body-item">
                                        <div className="textfield-cover">
                                            <TextField type="hidden" name="loanAmount" id="hiddenLoanAmt" onBlur={formik.handleBlur}  onChange={formik.handleChange} value={formik.values.loanAmount} ref={hiddenLoanAmountRef} />
                                            <TextField className="textfield-input-long" id="loan-amount-long" label="Loan Amount (50000 - 500000)" fullWidth onInput={(e) => {
                                                hiddenLoanAmountRef.current.value = e.target.value.replace(/[^0-9]/g, "");
                                                formik.setFieldValue('loanAmount', hiddenLoanAmountRef.current.value, true)
                                                if((e.target.value != '')){
                                                    e.target.value = parseInt(hiddenLoanAmountRef.current.value).toLocaleString()
                                                }
                                            }} required />
                                            {formik.touched.loanAmount || formik.errors.loanAmount ? (
                                                <div className="formik-error-div">{formik.errors.loanAmount}</div>
                                            ) : null}
                                        </div>
                                        <div className="select-cover">
                                            <FormControl className={`${classes.selectFormControl} select-form-control-cover`}>
                                                <InputLabel id="loan-duration-select-label">Loan Duration</InputLabel>
                                                <Select 
                                                    className="loan-duration-select-field"
                                                    labelId="loan-duration-select-label"
                                                    id="loan-duration-select"
                                                    value={formik.values.loanDuration}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    name="loanDuration"
                                                >
                                                    {/* <MenuItem value="1 Week">1 Week</MenuItem>
                                                    <MenuItem value="2 Weeks">2 Weeks</MenuItem>
                                                    <MenuItem value="3 Weeks">3 Weeks</MenuItem> */}
                                                    <MenuItem value="4 Weeks">4 Weeks</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div className="radio-cover">
                                            <FormControl component="fieldset" className={`${classes.radioFormControl} radio-form-control-cover`}>
                                                <FormLabel component="legend">Any outstanding loan?</FormLabel>
                                                <RadioGroup className="radio-group-tag-cover" aria-label="outstanding-loan" name="outstandingLoan" value={formik.values.outstandingLoan} onChange={formik.handleChange}>
                                                    <FormControlLabel value="no" control={<Radio />} label="No" />
                                                    <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                                                </RadioGroup>
                                            </FormControl>
                                        </div>
                                        {
                                            formik.values.outstandingLoan && formik.values.outstandingLoan == 'yes' ? 
                                            <div className="outstanding-loan-input-cover">
                                                <TextField className="textfield-input-long" name="outstandingLoanInput" id="outstanding-loan-input-long" label="Outstanding Loan (If Yes)" fullWidth value={formik.values.outstandingLoanInput} onBlur={formik.handleBlur} onChange={formik.handleChange} required />
                                            </div> : null
                                            
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="personal-details-cover">
                                <div className="personal-details-cover-header">
                                    <h2 className="header-title">Personal Details</h2>
                                </div>
                                <div className="personal-details-cover-body">
                                    <div className="personal-details-cover-body-item">
                                        <div className="textfield-cover">
                                            <div className="bvn-cover">
                                                <TextField className="textfield-input-long" name="bvn" id="bvn-long" type="number" label="BVN" fullWidth value={formik.values.bvn} onBlur={formik.handleBlur} onChange={formik.handleChange} onInput={(e) => {
                                                    e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0,11);
                                                }} required />
                                                {formik.touched.bvn || formik.errors.bvn ? (
                                                    <div className="formik-error-div">{formik.errors.bvn}</div>
                                                ) : null}
                                            </div>
                                            <div className="name-cover-flex">
                                                <div className="name-cover-item">
                                                    <TextField className="textfield-input-short" name="firstname" id="firstname-short" label="Firstname" fullWidth value={formik.values.firstname} onBlur={formik.handleBlur} onChange={formik.handleChange} onInput={(e) => {
                                                        e.target.value = e.target.value.replace(/[^a-zA-Z]/g, "");
                                                    }} required />
                                                </div>
                                                <div className="name-cover-item">
                                                    <TextField className="textfield-input-short" name="lastname" id="lastname-short" label="Lastname" fullWidth value={formik.values.lastname} onBlur={formik.handleBlur} onChange={formik.handleChange} onInput={(e) => {
                                                        e.target.value = e.target.value.replace(/[^a-zA-Z]/g, "");
                                                    }} required />
                                                </div>
                                            </div>  
                                            <div className="email-phoneno-cover-flex">
                                                <div className="email-phoneno-cover-item">
                                                    <TextField className="textfield-input-short" type="email" name="email" id="pocketmoni-email-short" label="Email" fullWidth value={formik.values.email} onBlur={formik.handleBlur} onChange={formik.handleChange} required />
                                                    {formik.touched.email || formik.errors.email ? (
                                                        <div className="formik-error-div">{formik.errors.email}</div>
                                                    ) : null}
                                                </div>
                                                <div className="email-phoneno-cover-item">
                                                    <TextField className="textfield-input-short" name="phoneno" id="phoneno-long" type="number" label="Phone No" fullWidth value={formik.values.phoneno} onBlur={formik.handleBlur} onChange={formik.handleChange} required />
                                                    {formik.touched.phoneno || formik.errors.phoneno ? (
                                                        <div className="formik-error-div">{formik.errors.phoneno}</div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="address-cover">
                                                <TextField className="textfield-input-long" name="homeAddress" id="home-address-long" label="Home Address" multiline rowsMax="4" fullWidth value={formik.values.homeAddress} onBlur={formik.handleBlur} onChange={formik.handleChange} required />
                                            </div>                                  
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="business-details-cover">
                                <div className="business-details-cover-header">
                                    <h2 className="header-title">Business Details</h2>
                                </div>
                                <div className="business-details-cover-body">
                                    <div className="textfield-cover">
                                        <div className="business-name-cover">
                                            <TextField className="textfield-input-long" name="businessName" id="business-name-long" label="Business Name" fullWidth value={formik.values.businessName} onBlur={formik.handleBlur} onChange={formik.handleChange} required />
                                        </div>
                                        <div className="business-type-cover">
                                            <FormControl className={`${classes.selectFormControl} form-control-cover`}>
                                                <InputLabel id="business-type-select-label">Business Type</InputLabel>
                                                <Select 
                                                    className="business-type-select-field"
                                                    labelId="business-type-select-label"
                                                    id="business-type-select"
                                                    value={formik.values.businessType}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    fullWidth
                                                    name="businessType"
                                                >
                                                    <MenuItem value="registered">Registered</MenuItem>
                                                    <MenuItem value="not registered">Not Registered</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                        {
                                            formik.values.businessType && formik.values.businessType == 'registered' ?
                                            <div className="rcno-cover">
                                                    <TextField className="textfield-input-long" type="number" name="rcno" id="rcno-long" label="RC No (If Registered)" fullWidth value={formik.values.rcno} onBlur={formik.handleBlur} onChange={formik.handleChange} required />
                                                    {formik.touched.rcno || formik.errors.rcno ? (
                                                        <div className="formik-error-div">{formik.errors.rcno}</div>
                                                    ) : null}
                                            </div> : null
                                        }
                                        <div className="wallet-tin-cover-flex">
                                            <div className="wallet-tin-cover-item">
                                                <TextField 
                                                className="textfield-input-short" 
                                                name="wallet" id="wallet-short" 
                                                type="number"
                                                label="Wallet ID" 
                                                fullWidth 
                                                value={formik.values.wallet} 
                                                onBlur={formik.handleBlur} 
                                                onChange={formik.handleChange}
                                                required />
                                                {formik.touched.wallet || formik.errors.wallet ? (
                                                    <div className="formik-error-div">{formik.errors.wallet}</div>
                                                ) : null}
                                            </div>
                                            <div className="wallet-tin-cover-item">
                                                <TextField className="textfield-input-short" name="tin" id="tin-short" type="number" label="TIN" fullWidth value={formik.values.tin} onBlur={formik.handleBlur} onChange={formik.handleChange} />
                                                {formik.touched.tin || formik.errors.tin ? (
                                                    <div className="formik-error-div">{formik.errors.tin}</div>
                                                ) : null}
                                            </div>
                                        </div> 
                                        <div className="transac-volume-cover">
                                        <TextField type="hidden" name="transacVolume" id="transac-volume-long"  value={formik.values.transacVolume} onBlur={formik.handleBlur} onChange={formik.handleChange} ref={hiddenTransacVolumeRef} />
                                            <TextField className="textfield-input-long" name="transacVolume" id="transac-volume-long" label="Average Monthly Transaction Volume" fullWidth onInput={(e) => {
                                                hiddenTransacVolumeRef.current.value = e.target.value.replace(/[^0-9]/g, "");
                                                formik.setFieldValue('transacVolume', hiddenTransacVolumeRef.current.value, true)
                                                if((e.target.value != '')){
                                                    e.target.value = parseInt(hiddenTransacVolumeRef.current.value).toLocaleString()
                                                }
                                            }} required />
                                            {formik.touched.transacVolume || formik.errors.transacVolume ? (
                                                <div className="formik-error-div">{formik.errors.transacVolume}</div>
                                            ) : null}
                                        </div>
                                        <div className="bank-name-cover">
                                            {/* <TextField className="textfield-input-long" name="bankname" id="bank-name-long" label="Bank Name" fullWidth value={formik.values.bankname} onBlur={formik.handleBlur} onChange={formik.handleChange} required /> */}
                                            <FormControl className={`${classes.selectFormControl} form-control-cover`}>
                                                <InputLabel id="bankname-select-label">Bank Name</InputLabel>
                                                <Select 
                                                    className="bankname-select-field"
                                                    labelId="bankname-select-label"
                                                    id="bankname-select"
                                                    value={formik.values.bankname}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    fullWidth
                                                    name="bankname"
                                                >
                                                    <MenuItem value="Access Bank">Access Bank</MenuItem>
                                                    <MenuItem value="Access (Diamond) Bank">Access (Diamond) Bank</MenuItem>
                                                    <MenuItem value="Citibank">Citibank</MenuItem>
                                                    <MenuItem value="Ecobank Nigeria">Ecobank Nigeria</MenuItem>
                                                    <MenuItem value="Heritage bank">Heritage Bank</MenuItem>
                                                    <MenuItem value="Fidelity bank">Fidelity Bank</MenuItem>
                                                    <MenuItem value="First Bank of Nigeria">First Bank of Nigeria</MenuItem>
                                                    <MenuItem value="First City Monument Bank (FCMB)">First City Monument Bank (FCMB)</MenuItem>
                                                    <MenuItem value="Mainstreet Bank">Mainstreet Bank</MenuItem>
                                                    <MenuItem value="Guaranty Trust Bank">Guaranty Trust Bank</MenuItem>
                                                    <MenuItem value="Heritage Bank Plc.">Heritage Bank Plc.</MenuItem>
                                                    <MenuItem value="Keystone Bank Limited">Keystone Bank Limited</MenuItem>
                                                    <MenuItem value="Polaris Bank">Polaris Bank</MenuItem>
                                                    <MenuItem value="Providus Bank">Providus Bank</MenuItem>
                                                    <MenuItem value="Stanbic IBTC Bank Nigeria Limited">Stanbic IBTC Bank Nigeria Limited</MenuItem>
                                                    <MenuItem value="Standard Chartered Bank">Standard Chartered Bank</MenuItem>
                                                    <MenuItem value="Sterling Bank">Sterling Bank</MenuItem>
                                                    <MenuItem value="Union Bank of Nigeria">Union Bank of Nigeria"</MenuItem>
                                                    <MenuItem value="United Bank for Africa(UBA)">United Bank for Africa(UBA)</MenuItem>
                                                    <MenuItem value="Unity Bank Plc">Unity Bank Plc</MenuItem>
                                                    <MenuItem value="Wema Bank">Wema Bank</MenuItem>
                                                    <MenuItem value="Zenith Bank">Zenith Bank</MenuItem>
                                                    <MenuItem value="Jaiz Bank Limited">Jaiz Bank Limited</MenuItem>
                                                    <MenuItem value="FCMB Group Plc">FCMB Group Plc</MenuItem>
                                                    <MenuItem value="FBN Holdings Plc">FBN Holdings Plc</MenuItem>
                                                    <MenuItem value="Stanbic IBTC Holdings Plc">Stanbic IBTC Holdings Plc</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div className="acctno-acctname-cover-flex">
                                            <div className="acctno-acctname-cover-item">
                                                <TextField className="textfield-input-short" name="acctNo" id="pocketmoni-email-short" type="number" label="Account Number" fullWidth value={formik.values.acctNo} onBlur={formik.handleBlur} onChange={formik.handleChange} required />
                                                {formik.touched.acctNo || formik.errors.acctNo ? (
                                                    <div className="formik-error-div">{formik.errors.acctNo}</div>
                                                ) : null}
                                            </div>
                                            <div className="acctno-acctname-cover-item">
                                                <TextField className="textfield-input-short" name="acctName" id="acctname-short" label="Account Name" fullWidth value={formik.values.acctName} onBlur={formik.handleBlur} onChange={formik.handleChange} required />
                                                {formik.touched.acctName || formik.errors.acctName ? (
                                                    <div className="formik-error-div">{formik.errors.acctName}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="business-activity-cover">
                                            <FormControl className={`${classes.selectFormControl} form-control-cover`}>
                                                <InputLabel id="business-activity-select-label">Business Activities</InputLabel>
                                                <Select 
                                                    className="business-activity-select-field"
                                                    labelId="business-activity-select-label"
                                                    id="business-activity-select"
                                                    value={formik.values.businessActivity}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    fullWidth
                                                    name="businessActivity"
                                                >
                                                    <MenuItem value="Advertising">Advertising</MenuItem>
                                                    <MenuItem value="Consulting">Consulting</MenuItem>
                                                    <MenuItem value="Hospitality">Hospitality</MenuItem>
                                                    <MenuItem value="Computer hardware and Software">computer hardware and software</MenuItem>
                                                    <MenuItem value="Construction and Real estate">construction and real estate</MenuItem>
                                                    <MenuItem value="Electrical Equipment and supplies">Electrical Equipment and supplies</MenuItem>
                                                    <MenuItem value="Electronic Component and supplies">Electronic Component and supplies</MenuItem>
                                                    <MenuItem value="Energy">Energy</MenuItem>
                                                    <MenuItem value="Environment">Environment</MenuItem>
                                                    <MenuItem value="Food and Beverage">Food and Beverage</MenuItem>
                                                    <MenuItem value="General Industrial Equipment">General Industrial Equipment</MenuItem>
                                                    <MenuItem value="Manufacturing and Processing">Manufacturing and Processing</MenuItem>
                                                    <MenuItem value="Printing and Publishing">Printing and Publishing</MenuItem>
                                                    <MenuItem value="Security and Protection">Security and Protection</MenuItem>
                                                    <MenuItem value="Transportation">Transportation</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div className="business-duration-label-cover">
                                            <p><InputLabel>How long as a pocketmoni agent ?</InputLabel></p>
                                        </div>
                                        <div className="business-duration-cover-flex">
                                            <div className="business-duration-cover-item">
                                                <FormControl className={`${classes.selectFormControl} form-control-cover`}>
                                                    <InputLabel id="business-duration-year-select-label">Years</InputLabel>
                                                    <Select 
                                                        className="business-duration-year-select-field"
                                                        labelId="business-duration-year-select-label"
                                                        id="business-duration-year-select"
                                                        value={formik.values.busDurationYear}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        fullWidth
                                                        name="busDurationYear"
                                                    >   
                                                        <MenuItem value={0}>0</MenuItem>
                                                        <MenuItem value={1}>1</MenuItem>
                                                        <MenuItem value={2}>2</MenuItem>
                                                        <MenuItem value={3}>3</MenuItem>
                                                        <MenuItem value={4}>4</MenuItem>
                                                        <MenuItem value={5}>5</MenuItem>
                                                        <MenuItem value={6}>6</MenuItem>
                                                        <MenuItem value={7}>7</MenuItem>
                                                        <MenuItem value={8}>8</MenuItem>
                                                        <MenuItem value={9}>9</MenuItem>
                                                        <MenuItem value={10}>10</MenuItem>
                                                        <MenuItem value={11}>11</MenuItem>
                                                        <MenuItem value={12}>12</MenuItem>
                                                        <MenuItem value={13}>13</MenuItem>
                                                        <MenuItem value={14}>14</MenuItem>
                                                        <MenuItem value={15}>15</MenuItem>
                                                        <MenuItem value={16}>16</MenuItem>
                                                        <MenuItem value={17}>17</MenuItem>
                                                        <MenuItem value={18}>18</MenuItem>
                                                        <MenuItem value={19}>19</MenuItem>
                                                        <MenuItem value={20}>20</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div className="business-duration-cover-item">
                                                <FormControl className={`${classes.selectFormControl} form-control-cover`}>
                                                    <InputLabel id="business-duration-month-select-label">Months</InputLabel>
                                                    <Select 
                                                        className="business-duration-month-select-field"
                                                        labelId="business-duration-month-select-label"
                                                        id="business-duration-month-select"
                                                        value={formik.values.busDurationMonth}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        fullWidth
                                                        name="busDurationMonth"
                                                    >
                                                        <MenuItem value={1}>1</MenuItem>
                                                        <MenuItem value={2}>2</MenuItem>
                                                        <MenuItem value={3}>3</MenuItem>
                                                        <MenuItem value={4}>4</MenuItem>
                                                        <MenuItem value={5}>5</MenuItem>
                                                        <MenuItem value={6}>6</MenuItem>
                                                        <MenuItem value={7}>7</MenuItem>
                                                        <MenuItem value={8}>8</MenuItem>
                                                        <MenuItem value={9}>9</MenuItem>
                                                        <MenuItem value={10}>10</MenuItem>
                                                        <MenuItem value={11}>11</MenuItem>
                                                        <MenuItem value={12}>12</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </div>                                
                                    </div>
                                </div>
                            </div>

                            <div className="agent-terms-details-cover">
                                <div className={`${classes.panelRoot} panel-root-cover`}>
                                    <ExpansionPanel className="expansion-panel-cover">
                                        <ExpansionPanelSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                            className="expansion-summary-cover"
                                        >
                                            <Typography className={`${classes.panelHeading} panel-heading-div`}>TERMS AND CONDITION</Typography>
                                        </ExpansionPanelSummary>
                                        <ExpansionPanelDetails className="expansion-details-cover">
                                            <div className="terms-condition-cover-item">
                                                <div className="agent-terms-details-header">
                                                    <div className="header-text-cover">
                                                        <p className="header-text">These Terms and Conditions apply to and regulate the provision of credit facilities advance by MKOBO Microfinance Bank Limited (”the Bank”). These standard Terms and Conditions set out the terms governing this Loan Facility. It is important that you read tthese Terms and Conditions carefully and keep them for future reference.</p>
                                                    </div>
                                                </div>
                                                <div className="agent-terms-details-body">
                                                    <div className="body-list-cover">
                                                        <TermsConditionList />
                                                    </div>
                                                </div>
                                            </div>
                                        </ExpansionPanelDetails>
                                    </ExpansionPanel>
                                </div>
                            </div>

                            <div className="agent-covenant-details-cover-footer">
                                <div className="footer-header-cover">
                                    <h2 className="footer-header-text">THE AGENT COVENANTS</h2>
                                </div>
                                <div className="footer-header-input-cover">
                                    <div className="footer-header-input-cover-flex">
                                        <div className="footer-header-input-cover-item">
                                            <div className="footer-header-input-text-cover">
                                                {/* <p className="footer-header-input-text">I/We certify that all information furnished by me/us is true, correct and complete. I/We have no borrowing arrangement with any bank and there are no overdues/statutory dues by me or the firm/company. No legal action has been taken against me/firm/company.I shall furnish all other information that may be required by Bank in connection with my application. The Information may also be exchanged by you with any agency you may deem fit you, your representative of any other agencies as authorized by you. You may take appropriate safeguards/action for recovery of bank’s unpaidloansincluding publication of defaulter’s name in website/ submission to Credit bureau agencies. <br /><br /><b>I agree to be bound by the Loan Policy of MKOBO Microfinance Bank Limited and be responsible for paying the entire loan amount availed  by  me in  accordancewiththe  payment  terms  and  conditions,  failing  which  appropriate  action  (legal  or  otherwise)  may  be initiated against me.</b></p> */}
                                                <p className="footer-header-input-text">I covenant to repay the loan as and when due. In the event that I fail to repay the loan as agreed, and the loan becomes delinquent, the bank shall have the right to report the delinquent loan to the CBN through the Credit Risk Management System (CRMS) or by any other means and request the CBN exercise its regulatory power to direct all banks and other financial institutions under its regulatory purview to set-off my indebtedness from any money standing to my credit in any bank account and from any other financial assets they may be holding for my benefit.<br /><br />
I covenant and warrant that the bank shall have power to set-off my indebtedness under this loan agreement from all such monies and funds standing to my credit/benefit in any and all such accounts or from any other financial assets belonging to me and in the custody of any such bank.<br /><br />
I hereby waive any right of confidentiality whether arising under common law or statute or in any other manner whatsoever and irrevocably agree that I shall not argue to the contrary before any court of law, tribunal administrative authority or any other body acting in any judicial or quasi-judicial capacity.”<br />
The above conditions were read to me/us and interpreted in the language I/we understand. I/we after reading and understanding the above conditions agreed to the terms and conditions and hereby append my/our signature(s) below:</p>
                                            </div>
                                            <div className="footer-header-textfield-cover-flex">
                                                <div className="footer-header-textfield-cover-item">
                                                    <TextField className="textfield-input-long" name="footerAgentName" id="footer-agent-name-long" label="Agent's Name" fullWidth value={formik.values.footerAgentName !== ''? formik.values.footerAgentName : formik.values.firstname+' '+formik.values.lastname} onBlur={formik.handleBlur} onChange={formik.handleChange} inputProps={{
                                                        readOnly: true
                                                    }} required />
                                                </div>
                                                <div className="footer-header-textfield-cover-item">
                                                    <TextField className="textfield-input-long" name="footerAgentSign" id="footer-agent-sign-long" label="Agent's Signature" fullWidth value={formik.values.footerAgentSign} onBlur={formik.handleBlur} onChange={formik.handleChange} required />
                                                </div>
                                            </div>
                                            <div className="footer-header-checkbox-cover-flex">
                                                <div className="footer-header-checkbox-cover-item">
                                                    <FormControl component="fieldset" className="checkbox-form-control-cover">
                                                        <FormGroup aria-label="position" row>
                                                            <FormControlLabel
                                                                checked={isCovenantAgree ? isCovenantAgree: false}
                                                                value={isCovenantAgree}
                                                                control={<Checkbox color="primary" />}
                                                                label="I Agree"
                                                                labelPlacement="end"
                                                                name="covenantAgree"
                                                                onChange={handleCheckbox}
                                                                required
                                                                ref={covenantAgreeRef}
                                                                id="covenant_agree"
                                                            />
                                                        </FormGroup>
                                                    </FormControl>
                                                </div>
                                                <div className="footer-header-checkbox-cover-item">
                                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                        <KeyboardDatePicker
                                                            disableToolbar
                                                            variant="inline"
                                                            format="MM/dd/yyyy"
                                                            margin="normal"
                                                            id="date-picker-inline"
                                                            // label="Date picker inline"
                                                            value={formik.values.applicationDate}
                                                            name="applicationDate"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            KeyboardButtonProps={{
                                                                'aria-label': 'change date',
                                                            }}
                                                            fullWidth
                                                        />
                                                    </MuiPickersUtilsProvider>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="agent-document-upload-cover">
                                <div className="agent-document-upload-header-cover">
                                    <h2 className="upload-header-text">AGENT DOCUMENT UPLOAD</h2>
                                </div>
                                <div className="agent-document-upload-body-cover">
                                    <div className="agent-document-upload-body-cover-flex">
                                        <div className="agent-document-upload-body-cover-item">
                                            <div className="upload-btn-cover-flex">
                                                <div className="upload-btn-cover-item">
                                                    <div className="upload-label-cover">
                                                        <label className="upload-btn-cover-label" htmlFor="agent-identity-upload">
                                                            <input type="file" accept="image/*" style={{visibility: 'hidden', width: '0px', height: '0px'}} id="agent-identity-upload" name="agentIdentityUpload" ref={identityFileRef} onChange={handleFileChange} required/>
                                                            <Button
                                                                variant="contained"
                                                                className={`${classes.agentIdBtn} agent-id-util-btn`}
                                                                color="primary"
                                                                startIcon={<CloudUploadIcon />}
                                                                onClick={() => identityFileRef.current.click()}
                                                                // onClick={(link) => handleUploadBtnClick('https://driveuploader.com/upload/j5bnxM7HIl/')}
                                                                // href="https://driveuploader.com/upload/j5bnxM7HIl/"
                                                            >
                                                                UPLOAD IDENTITY CARD
                                                            </Button>
                                                        </label>
                                                        <div className="identity-file-display-container">
                                                            <div className="identity-file-display-cover">
                                                                <img className="identity-file-display-img" id="identity-file-display-img" src={''} alt={''} ref={idDisplayRef}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="upload-btn-cover-item">
                                                    <div className="upload-label-cover">
                                                        <label className="upload-btn-cover-label" htmlFor="agent-utility-upload">
                                                            <input type="file" accept="image/*" style={{visibility: 'hidden', width: '0px', height: '0px'}} id="agent-utility-upload" name="agentUtilityUpload" ref={utilityFileRef} onChange={handleFileChange} required/>
                                                            <Button
                                                                variant="contained"
                                                                className={`${classes.agentIdBtn} agent-id-util-btn`}
                                                                color="primary"
                                                                startIcon={<CloudUploadIcon />}
                                                                onClick={() => utilityFileRef.current.click()}
                                                                // onClick={(link) => handleUploadBtnClick('https://driveuploader.com/upload/j5bnxM7HIl/')}
                                                                // href="https://driveuploader.com/upload/JXPEQMiHey/"
                                                            >
                                                                UPLOAD UTILITY BILL
                                                            </Button>
                                                        </label>
                                                        <div className="utility-file-display-container">
                                                            <div className="utility-file-display-cover">
                                                                <img className="utility-file-display-img" src={''} alt={''} ref={utilDisplayRef} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="upload-btn-cover-item">
                                                    <div className="upload-label-cover">
                                                        <label className="upload-btn-cover-label" htmlFor="agent-passport-upload">
                                                            <input type="file" accept="image/*" style={{visibility: 'hidden', width: '0px', height: '0px'}} id="agent-passport-upload" name="agentPassportUpload" ref={passportFileRef} onChange={handleFileChange} />
                                                            <Button
                                                                variant="contained"
                                                                className={`${classes.agentIdBtn} agent-id-util-btn`}
                                                                color="primary"
                                                                startIcon={<CloudUploadIcon />}
                                                                onClick={() => passportFileRef.current.click()}
                                                                // href="https://driveuploader.com/upload/xmafYPwLk2/"
                                                            >
                                                                CAC DOCUMENT
                                                            </Button>
                                                        </label>
                                                        <div className="passport-file-display-container">
                                                            <div className="passport-file-display-cover">
                                                                <img className="passport-file-display-img" src={''} alt={''} ref={passportDisplayRef} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="agree-print-submit-details-cover">
                                <div className="agree-print-submit-flex">
                                    <div className="agree-print-submit-item">
                                        <div className="agree-cover">
                                            <FormControl component="fieldset" className="checkbox-form-control-cover">
                                                <FormGroup aria-label="position" row>
                                                    <FormControlLabel
                                                        checked={isTermsAgree ? isTermsAgree: false}
                                                        value={isTermsAgree}
                                                        control={<Checkbox color="primary" />}
                                                        label="I have read and agreed to the terms and condition of this application, as well as the entire loan policy of MKOBO Micrfinance Bank Limited"
                                                        labelPlacement="end"
                                                        name="termsAgree"
                                                        onChange={handleCheckbox}
                                                        // ref={termsAgreeRef}
                                                        required
                                                    />
                                                </FormGroup>
                                            </FormControl>
                                        </div>
                                        <div className="print-submit-cover-flex">
                                            <div className="print-submit-cover-item">
                                                <div className="print-submit-btn-cover">
                                                    <Button
                                                        variant="contained"
                                                        color="default"
                                                        startIcon={<PrintIcon />}
                                                        className="print-submit-btn"
                                                        disabled
                                                    >
                                                        Print This Form
                                                    </Button>
                                                </div>
                                            </div>
                                            <div className="print-submit-cover-item">
                                                <div className="print-submit-btn-cover">
                                                    {
                                                        isBtnChecks.isTermsAgree && isBtnChecks.isCovenantAgree && isBtnChecks.agentIdentityUpload && isBtnChecks.agentUtilityUpload ? 

                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            startIcon={<SendIcon />}
                                                            className="print-submit-btn"
                                                            // onClick={() => console.log(formik.valuesidation)}
                                                            type="submit"
                                                            disabled={ isSubmitBtn ? true: false }
                                                        >
                                                            { isSubmitBtn ? (<i>...Processing</i>): 'Submit' }
                                                        </Button>:

                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            startIcon={<SendIcon />}
                                                            className="print-submit-btn"
                                                            // onClick={() => console.log(formik.valuesidation)}
                                                            type="submit"
                                                            disabled={true}
                                                            >
                                                            Submit
                                                        </Button>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AgentForm;